import {
    customerListUrl,
    searchHostCustomerListUrl,
    searchShipToByCustomerListUrl,
    salesCustomerAccountListUrl,
} from 'Utils/urlUtil';
import {post} from 'Utils/apiUtil';

export const DETACHED_FLAG = 'DETACHED_FLAG';
export const SHOW_OTHER_CUSTOMER_BUTTON = 'SHOW_OTHER_CUSTOMER_BUTTON';
export const IS_LAST_PAGE = 'IS_LAST_PAGE';
export const CUSTOMER_LIST = 'CUSTOMER_LIST';
export const B2B_PLATFORM_SHIPTO_LIST = 'B2B_PLATFORM_SHIPTO_LIST';

export const updateDetachedFlag = (detachedFlag) => (dispatch) =>
    dispatch({type: DETACHED_FLAG, payload: {detachedFlag}});

export const updateShowOtherCustomerButton = (showOtherCustomerButton) => (
    dispatch,
) =>
    dispatch({
        type: SHOW_OTHER_CUSTOMER_BUTTON,
        payload: {showOtherCustomerButton},
    });

export const updateIsLastPage = (isLastPage) => (dispatch) =>
    dispatch({type: IS_LAST_PAGE, payload: {isLastPage}});

// Send To Backend Request customer list
export function getCustomerList(data) {
    return async (dispatch, getState) => {
        const {customer, localData} = getState();
        const {detachedFlag} = customer;

        if (
            localData.roleType === 3 ||
            localData.roleType === 1 ||
            localData.roleType === 2
        )
            data.detachedFlag = detachedFlag;

        if (detachedFlag === false) {
            if (data.pageNum <= 1) {
                dispatch({
                    type: CUSTOMER_LIST,
                    payload: {customerList: [], pageNum: 1},
                });
            }

            if (localData.roleType === 0) {
                return dispatch(post(searchShipToByCustomerListUrl, data)).then(
                    async (res) => {
                        dispatch({
                            type: CUSTOMER_LIST,
                            payload: {
                                customerList: res.data,
                                pageNum: res.pageNum,
                            },
                        });
                        return res;
                    },
                );
            } else {
                let selectCustomerUrl = '';
                if (localData.roleType === 3 || localData.roleType === 1) {
                    if (typeof data.moduleFlag !== 'undefined') {
                        selectCustomerUrl = customerListUrl;
                    } else {
                        selectCustomerUrl = salesCustomerAccountListUrl;
                    }
                }

                return dispatch(
                    post(
                        localData.roleType === 2
                            ? searchHostCustomerListUrl
                            : selectCustomerUrl,
                        data,
                    ),
                ).then(async (res) => {
                    dispatch({
                        type: CUSTOMER_LIST,
                        payload: {customerList: res.data, pageNum: res.pageNum},
                    });

                    if (res.data.length < res.pageSize) {
                        if (localData.roleType === 3) {
                            if (data.queryKey) {
                                dispatch({
                                    type: IS_LAST_PAGE,
                                    payload: {isLastPage: true},
                                });
                            } else {
                                dispatch({
                                    type: SHOW_OTHER_CUSTOMER_BUTTON,
                                    payload: {showOtherCustomerButton: true},
                                });
                            }
                        } else if (
                            localData.roleType === 1 ||
                            localData.roleType === 2
                        ) {
                            dispatch({
                                type: IS_LAST_PAGE,
                                payload: {isLastPage: true},
                            });
                        }
                    }

                    return res;
                });
            }
        } else {
            return dispatch(
                post(
                    typeof data.moduleFlag !== 'undefined'
                        ? customerListUrl
                        : salesCustomerAccountListUrl,
                    data,
                ),
            ).then((res) => {
                dispatch({
                    type: CUSTOMER_LIST,
                    payload: {customerList: res.data, pageNum: data.pageNum},
                });

                if (res.data.length < res.pageSize) {
                    dispatch({type: IS_LAST_PAGE, payload: {isLastPage: true}});
                }

                return res;
            });
        }
    };
}

export const getB2bPlatformCustomerList = (data) => (dispatch) =>
    dispatch(post(customerListUrl, data)).then((res) => {
        let tempDataArr = [];
        if (res && res.data.length > 0) {
            res.data.map((resItem) => {
                let newData = {
                    shipToNo: resItem.shipTo,
                    subject: resItem.alphaName,
                };
                tempDataArr.push(newData);
            });
            res.data = tempDataArr;
        }
        dispatch({type: B2B_PLATFORM_SHIPTO_LIST, payload: res});
        return res;
    });
